import { createSlice } from "@reduxjs/toolkit";
const initialFilter = {
    fromDate: '',
    toDate: '',
    location: '',
    searchText: ""
};
const initialState = {
    page: 1,
    data: {},
    totalPages: 0,
    pageSize: 10,
    sortColumn: null,
    sortOrder: 'Acs',
    errorMessage: undefined,
    filterFields: initialFilter,
    locationMapCandidateList: [],
    masterDatas: {
        locationList: []
    }
}
const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
}
export const locationWithMapSlice = createSlice({
    name: 'locationWithMapListing',
    initialState,
    reducers: {
        updatelocationWithMapListings: (state, action) => {
            state.data = action.payload.data;
            state.page = Number(action.payload.page);
        },
        locationWithMapFailed: (state, action) => {
            state.errorMessage = action.payload;
        },
        updatePageSize: (state, action) => {
            state.pageSize = Number(action.payload.pageSize);
            state.page = 1;
        },
        setPage: (state, action) => {
            state.page = Number(action.payload.page);
        },
        setSorting: (state, action) => {
            const currentSortColumns = state.sortColumn;
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
        },
        setFilterData: (state, action) => {
            state.filterFields[action.payload.fieldName] = action.payload.value;
        },
        updateClearFilter: (state, action) => {
            state.filterFields = initialFilter
        },
        updateMasterDatas: (state, action) => {
            if(action.payload.locationList) {
                state.masterDatas.locationList = action.payload.locationList
            }
        },
        setMapCandidate: (state, action) => {
            state.locationMapCandidateList = action.payload
        }
        
    }
});

export const {
    updatelocationWithMapListings,
    locationWithMapFailed,
    updatePageSize,
    setPage,
    setSorting,
    setFilterData,
    updateMasterDatas,
    updateClearFilter,
    setMapCandidate,
} = locationWithMapSlice.actions;

export default locationWithMapSlice.reducer;
